import { FC } from 'react';
import { Box, Typography } from '@altermaind/web/ui';

type Props = {
  count: number;
};

export const FilterBadge: FC<Props> = ({ count }) => {
  if (count <= 0) return null;

  return (
    <Box
      position='absolute'
      top='-8px'
      right='-8px'
      backgroundColor='white'
      borderRadius='50%'
      width='20px'
      height='20px'
      display='flex'
      alignItems='center'
      justifyContent='center'
    >
      <Typography variant='p2/light' fontSize='xxs' color='primary'>
        {count}
      </Typography>
    </Box>
  );
};
